//just define a marker for extracting the text for translation
export const gettext = str => str;
